import styled from 'styled-components';

export const StyledList = styled.div`
  font-family: Poppins, sans-serif;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px rgba(0, 0, 0, .5);
  padding: 25px;
  margin: 30px;
  border-radius: 4px;
  font-size: 1.4em;
  color: #2B2932;
  
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    
    h4 {
      font-family: Poppins-Medium,Heltica,Arial,sans-serif;
      font-size: 14px;
      display: inline-block;
      margin-left: 10px;
      margin-bottom: 0;
    }
    
    * {
      margin: 0;
      padding: 0;
    }
  }
  .select {
          border-radius: 12px !important;
          border: 1px solid #B7B7B7;
          padding: 0 10px;
          color: #2B2932;
          
          .muted {
            color: #CCCCCC;
          }
        }

  table {
    margin: 0;
    
    thead tr th {
      border: 0;
      color: #B2B2B2;
      font-size: 12px;
    }
    
    tr td {
      vertical-align: middle;
      color: #8D8D8D;
    }
    
    button {
      text-transform: uppercase;
    }
  }
`;
